/**
 * Risk management utility functions
 */

/**
 * Check if the user has acknowledged the risk notice
 * @returns {boolean} Whether the user has acknowledged the risk
 */
export const hasAcknowledgedRisk = () => {
  return sessionStorage.getItem('riskGateAcknowledged') === 'true';
};

/**
 * Set the risk acknowledgment status in sessionStorage
 * @param {boolean} status - Acknowledgment status to set
 */
export const setRiskAcknowledgment = status => {
  sessionStorage.setItem('riskGateAcknowledged', status ? 'true' : 'false');
  if (status) {
    sessionStorage.setItem(
      'riskGateAcknowledgedDate',
      new Date().toISOString()
    );
  }
};

/**
 * Clear the risk acknowledgment status
 */
export const clearRiskAcknowledgment = () => {
  sessionStorage.removeItem('riskGateAcknowledged');
  sessionStorage.removeItem('riskGateAcknowledgedDate');
};
